import Supplier from './SupplierDetailController';

export default Supplier;
